(function () {
    var signup = document.getElementById('landing-signup');
    if (!signup) return;

    signup.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = document.getElementById('landing-email');
        var formNote = document.getElementById('landing-form-note');
        var value = (email && email.value || '').trim();
        var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

        if (!valid) {
            if (formNote) formNote.textContent = 'Enter a valid email to request access.';
            if (email) email.focus();
            return;
        }

        if (window.ghost && window.ghost.members && typeof window.ghost.members.openSignup === 'function') {
            window.ghost.members.openSignup({ email: value });
            if (formNote) formNote.textContent = 'Opening signup…';
            return;
        }

        window.location.hash = '#/portal/signup';
        if (formNote) formNote.textContent = 'Continue signup in the portal.';
    });
}());
